module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/feature01-a9fd59b03bea52345f5c14e8682707d1.svg";